var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.011 10.32C113.214 6.23999 133.728 11.856 149.019 23.988C155.205 28.896 160.554 34.878 164.595 41.67C173.589 56.787 176.469 75.114 174.267 92.565C172.065 110.016 165.003 126.624 155.43 141.378C148.092 152.682 139.11 163.143 127.827 170.514C116.544 177.885 102.777 181.968 89.439 180.042C77.874 178.371 67.308 172.347 58.338 164.856C38.526 148.299 25.473 124.005 22.143 98.403C19.554 78.486 23.088 57.057 35.526 41.289C49.278 23.856 71.292 15.888 92.148 10.746C92.769 10.593 93.39 10.452 94.011 10.32Z",
    fill: "#43D6AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.485 144C120.485 144 99.3805 143.97 70.1916 143.97C64.8612 143.97 61.0258 139.644 61.0258 135.8C61.115 121.212 60 121.212 60 106.624C60 102.78 64.8612 99 70.2131 99C99.3359 99 91.3178 100.351 120.508 100.351C125.837 100.351 128.316 104.632 128.316 104.632C128.316 104.632 129.827 131.634 128.358 137.582C126.889 143.53 120.485 144 120.485 144Z",
    fill: "#FAEAE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.807 16.566C44.55 17.652 7.93498 56.031 9.02398 102.285C10.077 147.009 46.083 183.015 90.807 184.068C137.064 184.068 183.774 137.19 183.774 91.101C183.735 48.6 141.531 16.566 90.807 16.566Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6172 114.001C92.4412 114.079 89.9272 116.828 90.002 120.142C90.0743 123.346 92.5464 125.926 95.6172 126.001C98.7932 126.001 102 122.643 102 119.341C101.998 116.296 99.0999 114.001 95.6172 114.001Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95.2135C81 95.2135 75.2981 77.083 81 68.2135C89.8695 54.4164 119.681 52.1508 123 68.2135C123.686 71.5325 123 76.892 123 76.892",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96 126C96 128.4 96 138 96 142.5",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138 82.5L148.5 72",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.476 94.0157L152.524 99.4842",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.115 152.215C123.115 152.215 101.093 152.179 70.6348 152.179C65.0726 152.179 61.0704 146.988 61.0704 142.374C61.1634 124.87 60 124.87 60 107.363C60 102.751 65.0726 98.2148 70.6571 98.2148C101.046 98.2148 92.6795 99.8361 123.139 99.8361C128.7 99.8361 131.287 104.973 131.287 104.973C131.287 104.973 132.863 137.376 131.33 144.513C129.797 151.651 123.115 152.215 123.115 152.215Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlock);
export default __webpack_public_path__ + "static/media/icon-unlock.fa5cce5f1c818ec177dd4c3362434d25.svg";
export { ForwardRef as ReactComponent };